import { useEffect, useState } from "react";
import { Sparkles, ArrowRight } from "lucide-react";
import { withUtm } from "@/components/thales/utm";

const STORAGE_KEY = "ai_planner_dismissed";

const AIPlannerFloating = () => {
  const [mounted, setMounted] = useState(false);
  const [visible, setVisible] = useState(false);
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    try {
      if (sessionStorage.getItem(STORAGE_KEY) === "1") {
        setClosed(true);
        return;
      }
    } catch (_) {}

    const timer = window.setTimeout(() => {
      setMounted(true);
      window.setTimeout(() => setVisible(true), 30);
    }, 20000);

    return () => window.clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setVisible(false);
    try {
      sessionStorage.setItem(STORAGE_KEY, "1");
    } catch (_) {}
    window.setTimeout(() => setClosed(true), 300);
  };

  if (closed || !mounted) return null;

  return (
    <div
      className={`fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-40 w-[calc(100vw-2rem)] sm:w-[360px] transition-all duration-300 ease-out ${
        visible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"
      }`}
      role="dialog"
      aria-label="Construisons votre prochain événement"
    >
      <div className="bg-white rounded-2xl shadow-xl border border-black/10 border-t-4 border-t-[#C6E278] p-4 sm:p-5 relative">
        <button
          type="button"
          onClick={handleClose}
          aria-label="Fermer"
          className="absolute top-2 right-2 w-7 h-7 inline-flex items-center justify-center rounded-full text-black/50 hover:text-black hover:bg-black/5 transition-colors"
        >
          ×
        </button>

        <span className="inline-flex items-center gap-1.5 rounded-full bg-black px-2.5 py-1 text-[11px] font-semibold text-[#C6E278]">
          <Sparkles className="h-3 w-3" />
          Nouveau · IA
        </span>

        <h3 className="mt-3 text-base sm:text-lg font-semibold text-black leading-snug">
          Construisons votre prochain événement
        </h3>
        <p className="mt-1.5 text-sm text-black/70 leading-relaxed">
          Décrivez votre événement et notre IA vous suggérera des options personnalisées.
        </p>

        <a
          href={withUtm("https://ai.ext.naboo.app/")}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-4 inline-flex w-full items-center justify-center gap-2 bg-cta-green text-black font-semibold rounded-xl px-4 py-2.5 text-sm hover:opacity-90 transition-opacity"
        >
          <Sparkles className="h-4 w-4" />
          Essayer l'IA planner
          <ArrowRight className="h-4 w-4" />
        </a>
      </div>
    </div>
  );
};

export default AIPlannerFloating;
